/*
 * @Author: 陈梦男 chenmengnan@piesat.cn
 * @Date: 2023-08-04 14:03:01
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-21 09:21:07
 * @FilePath: \web\src\api\Portal\marketApi.js
 * @Description: 矿业市场接口
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import axios from '@/utils/request';
import config from '@/config/config';

/** 获取热词接口 */
export const getHotTextApi = (option) => axios.get(`/bigdata/report/info/rank`, option);
/** 获取列表接口 */
export const getPageApi = (body, option) => axios.post(`/bigdata/report/info/page`, body, option);
/** 保存报告 */
export const saveApi = (params) => {
  return axios.post(`/bigdata/report/info/save`, params);
};
/** 批量修改报告 */
export const updateApi = (params) => {
  return config.isRequestError(axios.put(`/bigdata/report/info/update`, params));
};
/** 删除报告 */
export const deleteApi = (data) => {
  return axios.delete(`/bigdata/report/info/delete`, { data });
};
/* 导入 */
export const importApi = (params) => {
  return axios.post(`/bigdata/report/file/upload`, params);
};
/* 生成预览图片接口 */
export const getOverviewApi = (option) => axios.get(`/bigdata/report/file/overview/${option}`);
/* 生成预览图片接口 */

export const getDownloadApi = (
  params,
  option = {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
  },
) => axios.get(`/bigdata/report/file/download/${params.id}?check=${params.check}`, { ...option });
/** 获取热词接口 */
export const getDeepSeekCount = (id) => axios.get(`/bigdata/report/info/deepSeek/search?userId=${id}`);
/** 获取列表接口 */
export const setDeepSeekCount = (body) => axios.post(`/bigdata/report/info/deepSeek/count?userId=${body.userId}`, body);
